var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1217,
    height: 2,
    viewBox: "0 0 1217 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H1216.5",
    stroke: "url(#paint0_linear_4573_716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4573_716",
    x1: 0,
    y1: 1.5,
    x2: 1216.5,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443E65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDivider);
export default __webpack_public_path__ + "static/media/cart-divider.bada62c888aec8320ea883a2609b336d.svg";
export { ForwardRef as ReactComponent };